import { render, staticRenderFns } from "./manage-automations-modal.vue?vue&type=template&id=18ca0a14"
import script from "./manage-automations-modal.vue?vue&type=script&lang=js"
export * from "./manage-automations-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports